import renderingEngineCache from './renderingEngineCache.js';
export function getRenderingEngine(id) {
    return renderingEngineCache.get(id);
}
export function getRenderingEngines() {
    return renderingEngineCache.getAll();
}
export default getRenderingEngine;
